import { Component } from '@angular/core';

@Component({
  selector: 'oes-theme-guineabissau-sesap',
  templateUrl: './guineabissau-sesap.component.html',
  styleUrls: ['./guineabissau-sesap.component.scss']
})
export class GuineabissauSesapComponent {

  constructor() { }

}
